import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';
import RateCheckbox from './rateCheckbox';

export default function UngroupedRates({ rates, ratesChecked, onRateChecked }) {
    if (!rates) {
        return <Loader active />;
    }

    if (!rates.length) {
        return null;
    }

    return rates.map(rate => <RateCheckbox key={rate.id} className="rate-rules" rate={rate} onRateChecked={onRateChecked} ratesChecked={ratesChecked} />);
}

UngroupedRates.propTypes = {
    rates: PropTypes.array.isRequired,
    ratesChecked: PropTypes.array.isRequired,
    onRateChecked: PropTypes.func.isRequired
};
